import Head from "next/head";
import Home from "../components/Home/Home";

export default function Index() {
    return (
        <main>
            <Head>
                <title>Dinnerfy</title>
            </Head>
            <main>
                <Home />
            </main>
        </main>
    );
}
